import React from 'react'

import { IconButton, Modal, Paper, Slide } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import StarIcon from '@material-ui/icons/Star'

import { Container } from '../../components'
import { Premium } from '../../models/Concession'
import { PremiumForm } from './PremiumForm'
import { useConcessionStyles } from './styles'

interface Props {
    open: boolean
    premium?: Premium
    handleClose: () => void
    onCreated?: (premium: Premium) => void
    defaultActive?: boolean
}

export const PremiumModal: React.FC<Props> = ({
    open,
    premium,
    handleClose,
    onCreated,
    defaultActive,
}) => {
    const classes = useConcessionStyles()
    const isEditing = !!premium

    return (
        <Modal
            open={open}
            onClose={handleClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Slide direction="up" in={open}>
                <Paper className={classes.paper}>
                    <Container
                        direction="column"
                        style={{
                            width: 'min(640px, calc(100vw - 80px))',
                            maxHeight: 'calc(100vh - 120px)',
                            overflow: 'hidden',
                        }}
                    >
                        <div className={classes.header}>
                            <div className={classes.headerIcon}>
                                <StarIcon />
                            </div>
                            <Container direction="column" flex={1}>
                                <span className={classes.headerTitle}>
                                    {isEditing
                                        ? premium?.name || 'Edit Premium'
                                        : 'New Premium'}
                                </span>
                                <span className={classes.headerSubtitle}>
                                    {isEditing
                                        ? 'Edit this unit upcharge'
                                        : 'Create a unit upcharge for lease offers'}
                                </span>
                            </Container>
                            <IconButton size="small" onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                        {open && (
                            <PremiumForm
                                key={premium?.id ?? 'new'}
                                premium={premium}
                                handleClose={handleClose}
                                onCreated={onCreated}
                                defaultActive={defaultActive}
                            />
                        )}
                    </Container>
                </Paper>
            </Slide>
        </Modal>
    )
}
